"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import InputField from "../ui/InputField";
import TextareaField from "../ui/TextareaField";
import Button from "../ui/buttons";
import { ArrowDown, ChevronDown } from "lucide-react";
export default function SendComment() {
  const $ = _c(6);
  const [msg, setMsg] = React.useState("");
  React.useState("");
  React.useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex items-center gap-2 p-3 border border-DCDCDC bg-F8F8F8"><ArrowDown className="w-4 h-4 text-215EF9" /><h3 className="text-12-tamil-900 leading-[1.4] text-215EF9">உங்கள் கருத்தை எழுதுங்கள்</h3></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== msg) {
    t1 = <div className="flex-1 mb-4"><TextareaField placeholder={"\u0B92\u0BB0\u0BC1 \u0B95\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BC8 \u0B8E\u0BB4\u0BC1\u0BA4\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD"} value={msg} onChange={setMsg} className="w-full min-h-[120px] sm:min-h-[150px] text-sm sm:text-base" /></div>;
    $[1] = msg;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex justify-end"><Button variant="primary" onClick={_temp} className="cursor-pointer text-14-tamil-700 line-clamp-1 text-FFFFFF">கருத்து</Button></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="w-full md:w-[90%] lg:w-[884px] h-auto min-h-[250px] md:h-[295px] flex flex-col bg-F8F8F8 shadow-sm overflow-hidden">{t0}<div className="flex-1 flex flex-col p-3 sm:p-4 bg-EFF2F8 border border-DCDCDC">{t1}{t2}</div></div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {}